module.exports = __webpack_public_path__ + "img/02.8f101621.png";